import React, { useState } from "react";
import { useHistory, useLocation } from "@magento/venia-ui/lib/drivers";
import Modal from "@Components/Modal/modal";
import Button from "@magento/venia-ui/lib/components/Button/button";
import { useExponea } from "@Src_main/utils/useExponea";
import Icon from "@Components/Icon/icon";
import { useIntl } from "react-intl";
import defaultClasses from "./footerNav.module.scss";
export var FooterNavTab = _ref => {
  var _tableData$store, _tableData$store$sale;
  var {
    tableData = {},
    tableDescription: tableDescriptionProp,
    isMain,
    targetLocation,
    isLocationActive,
    animationActive,
    icon,
    text,
    override,
    id
  } = _ref;
  var {
    formatMessage
  } = useIntl();
  var {
    trackEvent
  } = useExponea();
  var history = useHistory();
  var location = useLocation();
  var currentSalesType = (_tableData$store = tableData.store) === null || _tableData$store === void 0 ? void 0 : (_tableData$store$sale = _tableData$store.sales_type) === null || _tableData$store$sale === void 0 ? void 0 : _tableData$store$sale.find(x => x.salesType === tableData.sales_type);
  var hasTable = currentSalesType === null || currentSalesType === void 0 ? void 0 : currentSalesType.hasTable;
  var hasPay = currentSalesType === null || currentSalesType === void 0 ? void 0 : currentSalesType.hasPay;
  var [isModalPromptOpen, setIsModalPromptOpen] = useState(false);
  var goToPage = (location, isActive) => {
    if (!isActive && location) history.push(location);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "uk-flex uk-flex-center"
  }, /*#__PURE__*/React.createElement("div", {
    id: id,
    className: "uk-animation-onclick uk-flex uk-flex-column uk-text-center ".concat(isMain && animationActive ? " uk-position-absolute uk-position-bottom  ".concat(defaultClasses.pulseButtonAnimation, " uk-flex-center ").concat(defaultClasses.mainCta, " ") : isMain ? "uk-position-absolute uk-position-bottom  uk-flex-center ".concat(defaultClasses.tableIcon, " ").concat(defaultClasses.mainCta, " ") : ""),
    onClick: () => {
      if (override) override();else if (isMain && tableData.cps && tableData.cpt && hasTable && !location.pathname.includes(formatMessage({
        id: "url.key.pay"
      }))) setIsModalPromptOpen(true);else {
        trackEvent("foterNav_click", {
          target_url: targetLocation
        });
        goToPage(targetLocation, isLocationActive);
      }
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "icon-".concat(icon),
    color: !isMain && isLocationActive ? "miscusi-red" : ""
  }), /*#__PURE__*/React.createElement("div", {
    className: !isMain && isLocationActive ? "uk-text-emphasis uk-text-xsmall" : !isMain ? "uk-text-xsmall uk-text-light" : "uk-text-small ".concat(defaultClasses.mainCtaTable)
  }, /*#__PURE__*/React.createElement("span", null, text))), isMain && tableData.cpt ? /*#__PURE__*/React.createElement(Modal, {
    id: "modal-recover-table",
    nameClass: "modal-recover-table",
    position: "uk-position-center",
    modalDialogClass: "uk-text-center section-full-rounded uk-padding-small",
    animation: "uk-animation-scale-up",
    modalCloseOutside: true,
    isOpen: isModalPromptOpen,
    onClose: () => {
      setIsModalPromptOpen(false);
    }
  }, /*#__PURE__*/React.createElement("h1", null, formatMessage({
    id: "order.casualdining.prompt"
  })), tableData.table && tableData.store ? /*#__PURE__*/React.createElement("div", {
    className: "uk-margin-small-bottom "
  }, /*#__PURE__*/React.createElement("span", null, tableDescriptionProp !== null ? formatMessage({
    id: "order.casualdining.prompt.text.1"
  }) + tableDescriptionProp + formatMessage({
    id: "order.casualdining.prompt.text.2"
  }) + tableData.store.commName + formatMessage({
    id: "order.casualdining.prompt.text.3"
  }) : "...")) : null, /*#__PURE__*/React.createElement("div", {
    className: "uk-flex uk-text-center",
    style: {
      gap: "10px"
    }
  }, /*#__PURE__*/React.createElement(Button, {
    id: "goToOrder",
    onClick: () => {
      setIsModalPromptOpen(false);
      history.push(formatMessage({
        id: "url.key.order"
      }));
    },
    color: "outline_primary",
    fullScreen: true,
    type: "submit"
  }, /*#__PURE__*/React.createElement("span", null, formatMessage({
    id: "button.continue.order"
  }))), /*#__PURE__*/React.createElement(Button, {
    id: "goToTableBtn",
    onClick: () => {
      var _tableData$store2;
      trackEvent("click_order_redirect", {
        store: (_tableData$store2 = tableData.store) === null || _tableData$store2 === void 0 ? void 0 : _tableData$store2.id,
        target_url: "OATT"
      }, false);
      setIsModalPromptOpen(false);
      var url = "".concat(hasPay ? formatMessage({
        id: "url.key.pay"
      }) : "", "/?cps=").concat(tableData.cps, "&cpt=").concat(tableData.cpt, "&sales_type=").concat(tableData.sales_type);
      history.push(url);
    },
    color: "primary",
    fullScreen: true,
    type: "submit"
  }, /*#__PURE__*/React.createElement("span", null, formatMessage({
    id: tableData.sales_type === "FASTCASUALDINING" ? "Order again" : "button.continue.table"
  }))))) : null);
};